import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Form, API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class FormularioService{
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/formulario`;
  }

  public getForm(id: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/${id}`);
  }

  public getFormularioByTipoTramiteId(dependenciaId: number, tipoTramiteId: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/byHojaDeVida/${dependenciaId}/${tipoTramiteId}`);
  }

  public downloadFormFile(radicado: string, fileName: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar/${radicado}/${fileName}`, { responseType: 'blob' });
  }
}
